import _ from 'lodash'
import type {
    DecorationPlugin,
    DecorationPluginFunction,
    DecorationSingleComponentPlugin,
    DecorationSingleComponentPluginFunction
} from './types'
import type {ComponentExportStructure} from '@wix/document-services-types'

const createPluginFuncFromSingleComponentPluginFunc = (
    plugin: DecorationSingleComponentPlugin,
    getPluginFuncToRun: (plugin: DecorationSingleComponentPlugin) => DecorationSingleComponentPluginFunction | undefined
): DecorationPluginFunction | undefined => {
    const pluginFunc = getPluginFuncToRun(plugin)
    if (!_.isFunction(pluginFunc)) {
        return
    }

    return (componentExport: ComponentExportStructure) => {
        for (const component of _.values(componentExport.components)) {
            if (plugin.components?.has(component.type) !== false) {
                pluginFunc(component)
            }
        }
    }
}

export const createPluginFromSingleComponentPlugin = (plugin: DecorationSingleComponentPlugin): DecorationPlugin => ({
    ...plugin,
    pack: createPluginFuncFromSingleComponentPluginFunc(plugin, p => p.pack),
    unpack: createPluginFuncFromSingleComponentPluginFunc(plugin, p => p.unpack)
})
